<div class="h-full flex flex-col rounded-2xl bg-white p-8">
  <ng-content></ng-content>
  @if (buttonList.length > 0) {
    <div class="flex flex-col flex-wrap lg:flex-row gap-1 pt-3">
      @for (button of buttonList; track getModelId($index, button)) {
        <button
          type="button"
          [ngClass]="[button.buttonStyle]"
          (click)="buttonClicked(button)"
          (keypress)="buttonClicked(button)"
          [disabled]="button.disabled"
          appRestrictedAccess
          [model]="button.permissionModel"
          [actions]="button.permissionActions"
          >
          @if (button.icon) {
            <fa-icon [icon]="button.icon"></fa-icon>
            }{{ button.title }}
          </button>
        }
      </div>
    }
  </div>
